module.exports = __webpack_public_path__ + "img/horizontal_3_3_9005.b6e70c2b.png";